import { z } from 'zod';
import { todayInTimezone } from '../dates';
import { emptyAsUndefined, id, optionalText, ymd } from './common';

const notFuture = (v: string | undefined) => v === undefined || v <= todayInTimezone();

/** Assign one or more existing accounts to an app (never creates accounts). */
export const assignAccountsSchema = z.object({
  accountIds: z.array(id).min(1, 'Select at least one account').max(100),
  /** First business day the account counts for the app (default: today). */
  assignedOn: emptyAsUndefined(ymd).refine(notFuture, 'Assignment date cannot be in the future'),
  notes: optionalText(2000),
});
export type AssignAccountsInput = z.output<typeof assignAccountsSchema>;

/** End an assignment period. The history row is kept forever. */
export const removeAssignmentSchema = z.object({
  /** Last business day the account counted for the app (default: today). */
  removedOn: emptyAsUndefined(ymd).refine(notFuture, 'Removal date cannot be in the future'),
  notes: optionalText(2000),
});
export type RemoveAssignmentInput = z.output<typeof removeAssignmentSchema>;

export const appAccountParams = z.object({ id, accountId: id });
